export default __webpack_public_path__ + "static/media/bkash_payment_logo.c1c7d2f6.png";